import { defineComponent, h, onMounted, ref, resolveComponent } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

import {
  CBadge,
  CSidebarNav,
  CNavItem,
  CNavGroup,
  CNavTitle,
} from '@coreui/vue'
import nav from '@/_nav.js'
import navAdmin from '@/_navAdmin.js'
import navReports from '@/_navReports.js'
import navReportsMultiTenant from '@/_navReportsMultiTenant.js'
import navLocal from '@/_navLocalServer.js'

import store from '@/store'

const runMode = process.env.VUE_APP_RUN_MODE
// console.log(runMode)

const normalizePath = (path) =>
  decodeURI(path)
    .replace(/#.*$/, '')
    .replace(/(index)?\.(html)$/, '')

const isActiveLink = (route, link) => {
  if (link === undefined) {
    return false
  }

  if (route.hash === link) {
    return true
  }

  const currentPath = normalizePath(route.path)
  const targetPath = normalizePath(link)

  return currentPath === targetPath
}

const isActiveItem = (route, item) => {
  if (isActiveLink(route, item.to)) {
    return true
  }

  if (item.items) {
    return item.items.some((child) => isActiveItem(route, child))
  }

  if (item.to == '/tenant/people-attributes/gender') {
    return true // 初期状態から子要素を展開する
  }

  return false // 初期状態は子要素を展開しない
}

const isAdminMenu = () => {
  return store.getters.isAdmin
}

const isCorporateMenu = () => {
  return store.getters.isCorporate
}

const hasMultiTenantMenu = () => {
  return store.getters.hasMultiTenant
}

const AppSidebarNav = defineComponent({
  name: 'AppSidebarNav',
  components: {
    CNavItem,
    CNavGroup,
    CNavTitle,
  },
  setup() {
    const route = useRoute()
    const firstRender = ref(true)

    onMounted(() => {
      firstRender.value = false
    })

    const renderItem = (item) => {
      if (item.items) {
        return h(
          CNavGroup,
          {
            ...(firstRender.value && {
              visible: item.items.some((child) => isActiveItem(route, child)),
            }),
          },
          {
            togglerContent: () => [
              h(resolveComponent('CIcon'), {
                customClassName: 'nav-icon',
                name: item.icon,
              }),
              item.name,
            ],
            default: () => item.items.map((child) => renderItem(child)),
          },
        )
      }

      return item.to
        ? h(
            RouterLink,
            {
              to: item.to,
              custom: true,
            },
            {
              default: (props) =>
                h(
                  resolveComponent(item.component),
                  {
                    active: props.isActive,
                    href: props.href,
                    onClick: () => props.navigate(),
                  },
                  {
                    default: () => [
                      item.icon &&
                        h(resolveComponent('CIcon'), {
                          customClassName: 'nav-icon',
                          name: item.icon,
                        }),
                      item.name,
                      item.badge &&
                        h(
                          CBadge,
                          {
                            class: 'ms-auto',
                            color: item.badge.color,
                          },
                          {
                            default: () => item.badge.text,
                          },
                        ),
                    ],
                  },
                ),
            },
          )
        : h(
            resolveComponent(item.component),
            {},
            {
              default: () => item.name,
            },
          )
    }

    if (runMode && runMode === 'localserver') {
      return () =>
        h(
          CSidebarNav,
          {},
          {
            default: () => navLocal.map((item) => renderItem(item)),
          },
        )
    }
    if (isAdminMenu()) {
      return () =>
        h(
          CSidebarNav,
          {},
          {
            default: () => navAdmin.map((item) => renderItem(item)),
          },
        )
    }
    if (isCorporateMenu()) {
      return () =>
        h(
          CSidebarNav,
          {},
          {
            default: () => nav.map((item) => renderItem(item)),
          },
        )
    } else if (hasMultiTenantMenu()) {
      return () =>
        h(
          CSidebarNav,
          {},
          {
            default: () =>
              navReportsMultiTenant.map((item) => renderItem(item)),
          },
        )
    } else {
      return () =>
        h(
          CSidebarNav,
          {},
          {
            default: () => navReports.map((item) => renderItem(item)),
          },
        )
    }
  },
})
export { AppSidebarNav }
